<template>
    <div class="link" @mouseover="mouseOnQuestion" @mouseout="mouseOutQuestion" :class="{ 'disabled': data.disabled === 0 }">
        <div class="link-text" @click="clickHandler">{{ text }}</div>
        <QuestionSimpleView
            class="question-view"
            v-if="isShowSimple"
            :content="simpleContent"
            @onview="mouseOnQuestion"
            @outview="mouseOutQuestion"
            positionTop="-16px"
            positionLeft="140px"
        />
    </div>
</template>

<script>
import QuestionSimpleView from "@/views/zhiji/components/questionEdit/answers/options/QuestionSimpleView";

export default {
    name: "Link",
    props: ["data", "row"],
    components: {
        QuestionSimpleView
    },
    data() {
        return {
            isShowSimple: false,
            simpleContent: ""
        };
    },
    computed: {
        text() {
            return this.data && this.data.value ? this.data.value : "";
        }
    },
    methods: {
        clickHandler(event) {
            this.$emit("colClick", {
                event: event,
                type: "Link"
            });
        },
        mouseOnQuestion() {
            this.simpleTimeout && clearTimeout(this.simpleTimeout);
            this.simpleTimeout = setTimeout(() => {
                this.isShowSimple = true;
                this.row.rowId &&
                    this.zhiji
                        .requestByServiceName("queryQuesSimpleById", {
                            questionId: this.row.rowId
                        })
                        .then(resp => {
                            this.simpleContent = resp.answerText;
                        });
            }, 500);
        },
        mouseOutQuestion() {
            this.simpleTimeout && clearTimeout(this.simpleTimeout);
            this.simpleTimeout = setTimeout(() => {
                this.isShowSimple = false;
            }, 500);
        }
    }
};
</script>

<style lang="less" scoped>
.link {
    position: relative;
    &:hover > .link-text {
        cursor: pointer;
        color: #2ec2ff;
        text-decoration: underline;
        &.disabled {
            color: #ccc;
            text-decoration: none;
        }
    }
    .link-text {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
.disabled {
    color: #ccc;
    pointer-events: none;
}
</style>
